// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ShowMoreButton_pagination__3PxLO","pagination__from-to":"ShowMoreButton_pagination__from-to__2rN5X","show-more-wrapper":"ShowMoreButton_show-more-wrapper__huiXd"};